import { DtoBase } from '../../../types/Dtos/DtoBase'

export class MoveFolderDto extends DtoBase {
  constructor(newParentId: string) {
    super({ parentId: newParentId })
  }
}
